<template>
  <section class="other-products card">
    <carousel navigator :data="props.productIds">
      <template #title>
        <h3>{{ $t('similar_products') }}</h3>
      </template>
      <template #default="{ item }">
        <div class="flex flex-col gap-8">
          <product-card :key="item" class="w-297px" :productId="item" />
        </div>
      </template>
    </carousel>
  </section>
</template>

<script setup lang="ts">
import Carousel from '@/components/common/carousel.vue'
import ProductCard from '@/components/product/product-card.vue'

const props = defineProps<{
  productIds: number[]
}>()
</script>

<style lang="scss" scoped></style>
